import { useTheme } from "../lib/theme/ThemeProvider";

/**
 * Wordmark — the product name in the display family. No icon: the name stands
 * on its own. Theme-aware text + tagline only.
 */
export default function Wordmark({
  size = "md",
  className,
}: {
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const { themeId, lex } = useTheme();
  const frontier = themeId === "frontier";
  const nameCls =
    size === "lg" ? "text-4xl md:text-5xl" : size === "sm" ? "text-xl" : "text-2xl";
  const tagline = frontier ? "Frontier Justice" : "War-Saga Engine";

  return (
    <div className={`flex flex-col items-center leading-none ${className ?? ""}`}>
      <div
        className={`font-display font-semibold uppercase tracking-[0.1em] text-bone ${nameCls}`}
        style={{ textShadow: "0 2px 18px rgba(0,0,0,0.7)" }}
      >
        {lex.productName}
      </div>
      <div className="mt-2 font-display text-base font-light uppercase tracking-[0.42em] text-ember-bright/80">
        {tagline}
      </div>
    </div>
  );
}
